const ua = window.navigator.userAgent
const androidAppREG = /didigsui.*_(.+)_\d+.*/ig
const iosAppREG = /ddudriver.*_(\d+\.\d+\.\d+).*/ig
const androidApp = androidAppREG.exec(ua) || ''
const iOSApp = iosAppREG.exec(ua) || ''
const isAndroidApp = !!androidApp
const isIOSApp = !!iOSApp
const isApp = isAndroidApp || isIOSApp || false
const appVersion = androidApp[1] || iOSApp[1] || ''
const isHonghu = /mvpdriver/.test(ua)

export default {
    isApp,
    isIOSApp,
    isAndroidApp,
    appVersion,
    isHonghu
}
